// import external dependencies
import 'jquery'

// Import everything from autoload
import './autoload/_bootstrap.js'

// Sane
import { Sane } from 'sane-ui'
import * as components from './components'

import { initBarba } from './util/barba'

// Lazysizes & useful polyfills.
import lazySizes from 'lazysizes'

if (window.app.environment === 'development') {
  lazySizes.cfg.init = false
}

lazySizes.cfg.expFactor = 4

// Load Events
jQuery(document).ready(() => {
  setTimeout(
    () => {
      if (window.app.environment === 'development') {
        lazySizes.init()
      }

      if (window.innerWidth < 768) {
        window.sane = Object.assign(
          { disableMotion: true },
          window.sane
        )
      }

      Sane.initSaneUI()
      Sane.initComponents(components, $('[data-component]'))
      initBarba()
    },
    window.app.environment === 'development' ? 1500 : 0
  )
})



// WEBPACK FOOTER //
// ./scripts/main.js